const selectricComponent = class extends HTMLElement {
    select = this.querySelector("select");
      
    connectedCallback() {
        this.initSelectric();  
    }
    initSelectric() {  
        const el = $(this.select);
        el.selectric({
                disableOnMobile: false,
                nativeOnMobile: false
        }); 
     }

};
window.customElements.define("selectric-component", selectricComponent); 
     